import React, { useState } from 'react';
import BulkActionModal from '../../components/base/BulkActionModalView';
import { capitalizeFirstLetter } from '../../utils';
import { TRANSACTION_RECORD_TYPE } from '../../containers/record/records/TransactionList';
import { CustomTitleWithDropDown } from '../customer/CustomTitleWithDropDown';
import { RejectReasons, RecallReasons } from '../../config/CustomEnums';
import './TransactionBulkActionPrompt.scss';
import { TransactionCard }  from '../../containers/record/records/RecentTransactions'

function TransactionBulkActionPrompt(props) {
  const event = props.event; //approve, pass, reject, recall, recall_with_reason
  const items = props.items;
  const show = props.show;
  const onHide = props.onHide || (() => { });
  const action = props.action || (() => { });
  const isSpotCheck = props.isSpotCheck;

  const recalledReason = props.recalledReason || { value: null, label: null };
  const setRecalledReason = props.setRecalledReason || (() => { });
  const [recallReasons, setRecallReasons] = useState(RecallReasons);
  const [isRecalling, setIsRecalling] = useState(false);
  const [isActionComplete, setIsActionComplete] = useState(false);
  const [recallResults, setRecallResults] = useState(null);
  const [recallError, setRecallError] = useState(null);

  const listTitle = 'Total transactions'
  const promptTitle = event
    ? (event !== 'recall_with_reason' ? `${capitalizeFirstLetter(event)} transaction` : 'Recall transaction') 
    : '';
  let promptMessage = 
  (!isActionComplete) ?
  (event
    ? (event !== 'recall_with_reason' ? `${capitalizeFirstLetter(event)} the transaction(s) below?` : 'Recall the transaction below?') 
    : '') : 'The transactions below have been updated';

  const promptRightButton = event ? (event !== 'recall_with_reason' ? capitalizeFirstLetter(event): '`Recall') : '';

  const clearRecalledReason = () => {
    setRecalledReason({ value: null, label: null });
  };

  const handleAction = async () => {
    if (isActionComplete) {
        await props.refreshTransactions?.();
        handleOnHide();
        return;
    }

    setIsRecalling(true);
    try {
        const response = await action();
        
        if (response?.payload) {
            const results = response.payload.results || [];
            setRecallResults(results.map(result => ({
                transactionId: result.id,
                success: result.success,
                error: result.error
            })));
            setRecallError(null);
            setIsActionComplete(true);
        }
    } catch (error) {
        setRecallError("Failed to recall transactions");
    } finally {
        setIsRecalling(false);
    }
};


  const handleOnHide = () => {
    onHide();
    setRecallReasons(RecallReasons);
    clearRecalledReason();
    setIsRecalling(false);
    setIsActionComplete(false);
    setRecallResults(null);
    setRecallError(null);
  };

  const localRecallFilterAction = (search = '') => {
    setRecallReasons(RecallReasons.filter(item => item.name.toLowerCase().includes(search.toLowerCase())));
  };

  const getListTileItems = () => {
    if (!isActionComplete) {
      return (
          <div className={`header-list-title`}>
            <div>{listTitle}</div>
            <div>{props.items.length}</div>
         </div>
      )
    }
    return <></>
  }
  const getActionPromptDetailItems = () => {
    if (isActionComplete) {
      // Determine the action type for success/fail messages
      const getActionMessage = (success) => {
        switch (event) {
          case 'approve':
            return success ? 'Approve success' : 'Approve fail';
          case 'pass':
            return success ? 'Pass success' : 'Pass fail';
          case 'recall':
          case 'recall_with_reason':
            return success ? 'Recall success' : 'Recall fail';
          default:
            return success ? 'Action success' : 'Action fail';
        }
      };

      return (
        <div className="action-results-container">
          {recallError ? (
            <div className="action-error">
              {recallError}
            </div>
          ) : null}
          <div className="action-results-list">
            {recallResults?.map((result, index) => (
              <div key={index} className="action-result-item">
                <div className={`action-result ${result.success ? 'success' : 'failed'}`}>
                  <span>ID: {result.transactionId || result.id }</span>
                </div>
                <div className={`action-result ${result.success ? 'success' : 'failed'}`}>
                  {getActionMessage(result.success)}
                </div>
              </div>
            ))}
          </div>
        </div>
      );
    }

    return (
      <div
        id="recent-transaction-scroll"
        className='bulk-selected-transaction-items'
      >
        {items.map((item, index) => (
          <div key={index}>
            <TransactionCard key={index} item={item} isDisplayCheckbox={false}   isSpotCheck={isSpotCheck} />
          </div>
        ))}
      </div>
    );
  };

  const getActionPromptFooterItems = () => {
    return (
      <div>
        {event === "recall_with_reason"
          ? <CustomTitleWithDropDown
            title={"Reason to recall"}
            defaultValue={recalledReason}
            setValue={setRecalledReason}
            source={recallReasons}
            localFilterAction={localRecallFilterAction}
            showRemoveButton={true}
            onRemoveButtonClick={clearRecalledReason}
            extraTitleClass='reject-reason-dropdown'
          />
          : null
        }
      </div>
    );
  };

  return (
    <BulkActionModal
      modalClassName={'transaction-modal'}
      className={'transaction-action-prompt'}
      showModal={show}
      onHide={handleOnHide}
      modalTitle={promptTitle}
      modalGeneralContent={promptMessage}
      modalListTitle={getListTileItems()}
      modalDetailContent={getActionPromptDetailItems()}
      modalFooterContent={!isActionComplete ? getActionPromptFooterItems(): null}
      actionName={isActionComplete ? 'Done' : promptRightButton}
      action={handleAction}
      showCancel={!isActionComplete}
      isLoading={isRecalling}
    />
  );
}

export default TransactionBulkActionPrompt;
